import { render, staticRenderFns } from "./teamChatTypingIndicator.vue?vue&type=template&id=63d845be&"
import script from "./teamChatTypingIndicator.vue?vue&type=script&lang=js&"
export * from "./teamChatTypingIndicator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports